module.exports = __webpack_public_path__ + "img/father-pic.89d2d679.svg";